import { clsx } from 'clsx'

import {
  ArrowLeftIcon,
  BufferIcon,
  Button,
  Flex,
  UnstyledButton,
  useBreakpoint,
} from '@buffer-mono/popcorn'

import { getPublishUrl } from '@buffer-mono/shared-utils/urls'
import { useCrossAppNavigate } from '../../common/hooks/useCrossAppNavigate'
import BufferLogoWithWords from './BufferLogoWithWords'

import styles from './Navigation.module.css'

import type { JSX } from 'react'

export default function Navigation(): JSX.Element {
  const breakpoint = useBreakpoint()
  const shouldUseLargeLogo = breakpoint === 'lg' || breakpoint === 'xl'

  const navigateCrossApp = useCrossAppNavigate()

  return (
    <nav
      aria-label="Main menu"
      className={clsx(styles.nav, {
        [styles.tight]: breakpoint === 'md',
        [styles.wide]: breakpoint === 'lg' || breakpoint === 'xl',
      })}
    >
      {/* WCAG 2.4.1 Bypass Blocks — skip link lets keyboard/screen reader
          users jump past repeated navigation to the main content area.
          @see https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks.html */}
      <a
        href="#main"
        className={styles.skipToMain}
        onClick={(e): void => {
          e.preventDefault()
          document.getElementById('main')?.focus()
        }}
      >
        Skip to main content
      </a>
      <Flex
        direction="row"
        fullWidth
        align="center"
        className={styles.leftContainer}
      >
        <Flex align="center" className={styles.logoContainer}>
          {shouldUseLargeLogo ? (
            <BufferLogoWithWords className={styles.largeLogo} />
          ) : (
            <UnstyledButton
              className={styles.logoButton}
              aria-label="Go to Publish"
              onClick={(): void => navigateCrossApp(getPublishUrl())}
            >
              <BufferIcon />
            </UnstyledButton>
          )}
        </Flex>
        <Flex align="center" className={styles.backButton}>
          <Button as="a" variant="tertiary" href={getPublishUrl()}>
            <ArrowLeftIcon /> Back to Main App
          </Button>
        </Flex>
      </Flex>
    </nav>
  )
}
